import { useCallback, useMemo } from 'react'

import { convertValuesToOptionValues } from 'features/views/attributes/hooks/useDropdownAttributeDisplayState'

type UseSectionDropdownAttributeEditorStateProps = {
    value?: string[] | string
    onChange: (value: string[] | string) => void
    field: FieldDto
}

export function useSectionDropdownAttributeEditorState({
    value,
    onChange,
    field,
}: UseSectionDropdownAttributeEditorStateProps) {
    const isSingle = field.type === 'dropdown'
    const defaultValue = isSingle ? '' : []
    const localValue = value ?? defaultValue

    const allOptions = useMemo(() => {
        const allValues = field.options?.options?.map((option) => option.value!) ?? []
        return convertValuesToOptionValues(field, allValues)
    }, [field])

    const handleChange = useCallback(
        (newValue: string[] | string) => {
            onChange(newValue)
        },
        [onChange]
    )

    return {
        localValue,
        handleChange,
        isSingle,
        allOptions,
    }
}
